import { Config } from 'Shared/resources/assets/app/js/utils/Config';

export const config = function (key, defaultValue) {
    return Config.get(key, defaultValue);
};
